import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StakeholderTypeEnum } from '@cupoui/shared/model/enumerations/stakeholder-type.enum';

@Injectable({
  providedIn: 'root'
})
export class StakeholderService {
  jsonPatchHeaders = new HttpHeaders({ 'Content-Type': 'application/json-patch+json' });

  constructor(private http: HttpClient) {}

  public getStakeholderIconFullPath(stakeholderTypeEnum: any): string {
    return '/content/icons/' + this.addIconToCaseStakeholder(stakeholderTypeEnum) + '.svg';
  }

  addIconToCaseStakeholder(stakeholderTypeEnum: any): string {
    let iconName: string;
    switch (stakeholderTypeEnum) {
      case StakeholderTypeEnum.endUser:
        iconName = 'end-user';
        break;

      case StakeholderTypeEnum.policyHolder:
        iconName = 'policy-holder';
        break;

      case StakeholderTypeEnum.reporter:
        iconName = 'reporter';
        break;

      case StakeholderTypeEnum.person:
        iconName = 'person';
        break;

      case StakeholderTypeEnum.medicalAdvisor:
      case StakeholderTypeEnum.crisisPsychologist:
        iconName = 'medical-person';
        break;

      case StakeholderTypeEnum.dentist:
      case StakeholderTypeEnum.doctorOutpatientClinic:
      case StakeholderTypeEnum.hospital:
        iconName = 'place-of-treatment';
        break;

      case StakeholderTypeEnum.hotel:
        iconName = 'hotel';
        break;

      case StakeholderTypeEnum.airAmbulanceCompany:
        iconName = 'ambulance-flight';
        break;

      case StakeholderTypeEnum.charterFights:
      case StakeholderTypeEnum.schedulesFights:
      case StakeholderTypeEnum.airline:
        iconName = 'airline';
        break;

      case StakeholderTypeEnum.ambulanceCompany:
        iconName = 'ground-ambulance';
        break;

      case StakeholderTypeEnum.taxi:
        iconName = 'taxi';
        break;

      case StakeholderTypeEnum.escortDoctor:
      case StakeholderTypeEnum.escortNurse:
        iconName = 'medical-escort';
        break;

      case StakeholderTypeEnum.assistanceContact:
      case StakeholderTypeEnum.billingOfficeAdministration:
      case StakeholderTypeEnum.sosServiceOffice:
        iconName = 'agent';
        break;

      case StakeholderTypeEnum.patientsDoctorHospital:
        iconName = 'patients-doctor-or-hospital';
        break;

      case StakeholderTypeEnum.pharmacy:
      case StakeholderTypeEnum.airport:
      case StakeholderTypeEnum.travelAgency:
      case StakeholderTypeEnum.churchesAndPriests:
      case StakeholderTypeEnum.embassyConsulate:
      case StakeholderTypeEnum.funeralCompany:
      case StakeholderTypeEnum.lawyers:
      case StakeholderTypeEnum.policeAndRescueSearch:
      case StakeholderTypeEnum.shippingAndCargoCompany:
      default:
        iconName = 'other';
        break;
    }
    return iconName;
  }
}
